import React from "react";
import { Box, Button, Typography } from "@material-ui/core";

interface BooleanRadioGroupProps {
  label: string;
  value: boolean | undefined;
  onChange: (value: boolean) => void;
  disabled?: boolean;
}

export const BooleanRadioGroup: React.FC<BooleanRadioGroupProps> = ({
  label,
  value,
  onChange,
  disabled = false
}) => {
  return (
    <Box>
      <Typography variant="subtitle1">{label}</Typography>
      <Box display="flex" flexDirection="row" mt="0.5rem">
        <Box mr={2}>
          <Button
            variant={value === true ? "contained" : "outlined"}
            color="primary"
            onClick={() => onChange(true)}
            disabled={disabled}
          >
            Yes
          </Button>
        </Box>
        <Button
          variant={value === false ? "contained" : "outlined"}
          color="primary"
          onClick={() => onChange(false)}
          disabled={disabled}
        >
          No
        </Button>
      </Box>
    </Box>
  );
};

